import { shallowEqual, useSelector } from 'react-redux'
import useLocalStorage from 'common/hooks/useLocalStorage'

// Favoris clients de l'utilisateur, persistés en localStorage par login. Partagé entre la liste
// des clients et la fiche client (même clé de stockage).
const useCustomerFavorites = () => {
    const login = useSelector(store => store.app.user?.login, shallowEqual)
    const [favorites = [], setFavorites] = useLocalStorage(`customers:favorites:${login ?? 'anon'}`, [])

    const isFavorite = (id) => (favorites ?? []).includes(id)
    const toggleFavorite = (id) => setFavorites(prev => ((prev ?? []).includes(id) ? prev.filter(x => x !== id) : [...(prev ?? []), id]))

    return { favorites: favorites ?? [], isFavorite, toggleFavorite }
}

export default useCustomerFavorites
